import React from 'react'
import Header from '../../../Components/Header/Header'
import Banner from './assets/Banner.webp'
import style from './JHero.module.css'


const Hero = () => {
    return (
        <>
            <Header />
            <div className={style.JHeroSection}>
                        <img src={Banner} alt="Krishna Janmastami 2025" />
            </div>
        </>
    )
}

export default Hero
